import { useTranslation } from "react-i18next"
import { BetterDocPreferredCareProviderSummary } from "@/modules/patients/detail/better-doc/de/components/better-doc-preferred-care-provider/better-doc-preferred-care-provider-summary"
import type { BetterDocCareProviderSearchItem } from "@/modules/patients/detail/better-doc/de/services/betterDocCareProviderSearchQuery"

type BetterDocPreferredCareProviderResultProps = {
  careProviders: ReadonlyArray<BetterDocCareProviderSearchItem>
  onSelect: (careProvider: BetterDocCareProviderSearchItem) => void
}

export const BetterDocPreferredCareProviderResult = ({
  careProviders,
  onSelect,
}: BetterDocPreferredCareProviderResultProps) => {
  const { t } = useTranslation()

  return (
    <ul className="scrollbar-thumb-rounded-full scrollbar-w-1 hover:scrollbar-thumb-surface-pressed grid max-h-96 scrollbar-thin scrollbar-thumb-transparent scrollbar-track-transparent gap-2 overflow-y-auto pr-2">
      {careProviders.map((careProvider) => (
        <li key={careProvider.medhubActivityId}>
          <button
            type="button"
            className="border-border bg-surface hover:bg-surface-hovered focus-visible:outline-primary-focused flex w-full items-center justify-between gap-4 rounded-xl border px-4 py-3 text-left focus-visible:outline-2"
            data-testid="better-doc-preferred-care-provider-result-row"
            onClick={() => onSelect(careProvider)}>
            <BetterDocPreferredCareProviderSummary careProvider={careProvider} />
            <span className="text-primary shrink-0 text-sm font-medium">
              {t("episodeOfCare.betterDoc.preferredCareProvider.select")}
            </span>
          </button>
        </li>
      ))}
    </ul>
  )
}
